import { OTP, OTP_SUCCESS, OTP_FAILURE } from "../Constants";

const init = {
    email: {},
    otp: {},
    data: {}
};

const OtpReducer = (state = init, action) => {
    switch (action.type) {
        case OTP:
            return { ...state, loading: true };
        case OTP_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case OTP_FAILURE:
            return { ...state, loading: false, data: action.payload };
        default:
            return state;
    }
};

export default OtpReducer;